import styled from 'styled-components';

export const CardsWrapper = styled.div`
  display: none;

  @media (min-width: ${({ theme }) => theme.mediaQueries.sm}) {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 16px;
  }
`;
